<template>
  <span>

    <Menu/>
    
    <span v-if="$store.getters.getUserLoading || $store.getters.getTasksLoading">

        <b-row>
        <b-col sm="0" md="4"></b-col>
        <b-col sm="1" md="4">
            <b-card 
            class="mt-3"
            img-src="PTLogo-NoText.png"
            >
            <b-card-title>

                <h2 class="display-4">
                
                Principal Task

                </h2>

            </b-card-title>

            <b-card-sub-title class="lead">
                Built for productive people (and those who want to be)
            </b-card-sub-title>

            <template v-slot:footer>
                <b-row
                    v-if="isLoading"
                    class="justify-content-center">

                    <b-spinner
                    :style="{visibility: isLoading ? 'visible' : 'hidden'}"
                    label="Spinning"/>
                    
                    <b-spinner
                    :style="{visibility: isLoading ? 'visible' : 'hidden'}"
                    type="grow"
                    label="Spinning"/>

                    <b-spinner
                    :style="{visibility: isLoading ? 'visible' : 'hidden'}"
                    variant="primary"
                    label="Spinning"/>

                    <b-spinner
                    :style="{visibility: isLoading ? 'visible' : 'hidden'}"
                    variant="primary"
                    type="grow"
                    label="Spinning"/>

                    <b-spinner
                    :style="{visibility: isLoading ? 'visible' : 'hidden'}"
                    variant="success"
                    label="Spinning"/>

                    <b-spinner
                    :style="{visibility: isLoading ? 'visible' : 'hidden'}"
                    variant="success"
                    type="grow"
                    label="Spinning"/>

                </b-row>
            </template>

            </b-card>
        </b-col>
        <b-col sm="0" md="4"></b-col>

        </b-row>
    
    
<!-- <Loading
      v-if="loading"
      :isLoading="$store.getters.getUserLoading || $store.getters.getTasksLoading"/> -->
    

    


  </span>
    
    <span v-else>

      <b-row class="pb-3">

                

        <b-col cols="2">

                    
          <b-img
            :rounded="true"
            :src="auth0User.picture"
            :fluid="true"
          />


        </b-col>

        <b-col cols="10">

          <h1 class="display-4">
            You're almost done
          </h1>

          <p class="lead">
            Provide the information below to complete your enrollment.
          </p>

                    

        </b-col>

      </b-row>

      <!-- <ProfileForm 
        :userData="this.auth0User"
        :displayForNewUser="true"
        @submitted:ProfileForm="onSubmit"/> -->

    <b-row>
        <b-col>
            <b-form
                @submit="onSubmit"
                @reset="onReset">
                    
                
                

                <b-form-row class="mt-2">
                    <b-col>
                        <p class="lead">
                            <b-link @click="collapse('personalData')" style="text-decoration:none;">
                                <b-icon :icon="visibility.personalDataIcon"/>
                                <b-icon icon="exclamation-triangle-fill" variant="danger" v-if="typeof localFormValidation.personalData != 'undefined' && localFormValidation.personalData !== null && !localFormValidation.personalData"/>
                                Personal Details
                            </b-link>
                        </p>
                    </b-col>
                </b-form-row>

                <b-collapse id="personalData" :visible="visibility.personalData">
                
                    <b-form-row class="mt-2">
                                
                        <b-col>
                        
                        <b-form-group
                            id="signup-firstName-group"
                            label="First Name"
                            label-for="firstName"
                            description="Your first name, or given name."
                            :state="localFormValidation.firstName" 
                            valid-feedback="Looks good!"
                            invalid-feedback="This information is required."
                        >
                                    
                            <b-form-input
                            id="firstName"
                            v-model.trim="localUserData.firstName" 
                            :state="localFormValidation.firstName"
                            />

                        </b-form-group>

                        </b-col>

                        <b-col>
                                    
                        <b-form-group
                            id="signup-lastName-group"
                            label="Last Name"
                            label-for="lastName"
                            description="Your last name, surname, or family name."
                            :state="localFormValidation.lastName" 
                            valid-feedback="Looks good!"
                            invalid-feedback="This information is required."
                        >
                                    
                            <b-form-input
                            id="lastName"
                            v-model.trim="localUserData.lastName" 
                            :state="localFormValidation.lastName"
                            />

                        </b-form-group>

                        </b-col>

                    </b-form-row>

                    <b-form-row>

                        <b-col cols="6">
                                    
                            <b-form-group
                                id="signup-goesBy-group"
                                label="Preferred Name"
                                label-for="goesBy"
                                description="Your nickname or alias."
                                :state="localFormValidation.goesBy" 
                                valid-feedback="Looks good!"
                                invalid-feedback="This information is required.">
                                        
                                <b-form-input
                                id="goesBy"
                                v-model.trim="localUserData.goesBy" 
                                :state="localFormValidation.goesBy">
                                
                                    <!--
                                        20200409 -- ZWS -- @TODO -- I'll likely need a way to
                                        implement this when adding this component to the
                                        sign-up page
                                    {{ this.auth0User.nickname }}
                                    -->
                                
                                </b-form-input>

                            </b-form-group>

                        </b-col>

                        <b-col>
                                    
                            <b-form-group
                                id="signup-timezone-group"
                                label="Timezone"
                                label-for="timezone"
                                description="The timezone in which you usually reside."
                                :state="localFormValidation.timezone"
                                valid-feedback="Looks good!"
                                invalid-feedback="This information is required.">
                                    
                                <b-form-select 
                                id="timezone"
                                v-model.trim="localUserData.timezone" 
                                :state="localFormValidation.timezone"
                                :options="validTimezones"
                                value-field="item"
                                text-field="name"
                                />

                            </b-form-group>

                        </b-col>

                    </b-form-row>

                    <b-form-row>

                        <b-col cols="6">

                            <b-form-group
                                id="signup-country-group"
                                label="Country"
                                label-for="country"
                                description="The country in which you usually reside."
                                :state="localFormValidation.country" 
                                valid-feedback="Looks good!"
                                invalid-feedback="This information is required."
                            >
                                        
                                <b-form-select
                                id="country"
                                v-model.trim="localUserData.country" 
                                :state="localFormValidation.country"
                                :options="countries"
                                value-field="Code"
                                text-field="Name"
                                />
                                

                            </b-form-group>

                        </b-col>

                    </b-form-row>

                    <b-form-row style="text-align:right;">
                        <b-col>
                            <b-button variant="success" @click="next('applicationOptions')">
                                Next
                            </b-button>
                        </b-col>
                    </b-form-row>

                </b-collapse>

                <b-form-row>
                    <b-col>
                        <p class="lead">
                            <b-link @click="collapse('applicationOptions')" style="text-decoration:none;">
                                <b-icon :icon="visibility.applicationOptionsIcon"/>
                                <b-icon icon="exclamation-triangle-fill" variant="danger" v-if="typeof localFormValidation.applicationOptions != 'undefined' && localFormValidation.applicationOptions !== null && !localFormValidation.applicationOptions"/>
                                Application Options
                            </b-link>
                        </p>
                    </b-col>
                </b-form-row>

                <b-collapse id="applicationOptions" :visible="visibility.applicationOptions">

                    <b-form-row>
                        <b-col cols="6">
                            <b-form-group
                                id="signup-loadDefaults-group"
                                label="Load Defaults"
                                label-for="loadDefaults"
                                description="Should default folders, contexts, etc be created?"
                                :state="localFormValidation.loadDefaults"
                                valid-feedback="Looks good!"
                                invalid-feedback="This information is required.">
                                    
                            <b-form-select 
                                id="loadDefaults"
                                v-model.trim="localUserData.loadDefaults" 
                                :state="localFormValidation.loadDefaults"
                                :options="yesornoOnly"
                                value-field="item"
                                text-field="name"/>

                            </b-form-group>
                        </b-col>
                    </b-form-row>

                    <b-form-row style="text-align:right;">
                        <b-col>
                            <b-button variant="warning" @click="next('personalData')" class="mr-2">
                                Previous
                            </b-button>
                            <b-button variant="success" @click="next('subscription')">
                                Next
                            </b-button>
                        </b-col>
                    </b-form-row>

                </b-collapse>

                <b-form-row>
                    <b-col>
                        <p class="lead">
                            <b-link @click="collapse('subscription')" style="text-decoration:none;">
                                <b-icon :icon="visibility.subscriptionIcon"/>
                                <b-icon icon="exclamation-triangle-fill" variant="danger" v-if="typeof localFormValidation.subscription != 'undefined' && localFormValidation.subscription !== null && !localFormValidation.subscription"/>
                                Subscription
                            </b-link>
                        </p>
                    </b-col>
                </b-form-row>

                <b-collapse id="subscription" :visible="visibility.subscription">

                    <b-form-row>
                        
                        <!-- @TODO: This group is required for v-model but it messes with layout -->
                        <b-form-radio-group
                                id="radio-group-2"
                                v-model="localUserData.subscriptionTier"
                                name="radio-sub-component"
                                >
                        
                        <b-col cols="12" md="6">

                            
                            
                            <b-card>

                                <h4>
                                    <b-form-radio 
                                        
                                        name="subscription-free" 
                                        value="free">Early Adopter</b-form-radio>
                                </h4>
                                <h6 class="text-secondary">Free Tier</h6>

                                <b-card-text>
                                    All of the features of Principal Task with none of the cost.  
                                    Recommended for students, individuals with low income, or those who desire
                                    to give Principal Task a try.
                                </b-card-text>

                                
                            </b-card>

                        </b-col>

                        <b-col cols="12" md="6">

                            <b-card>
                                
                                <h4>
                                    <b-form-radio 
                                        
                                        name="subscription-paid" 
                                        value="paid">
                                        
                                        Early Patron
                                    
                                    </b-form-radio>
                                </h4>
                                
                                <h6 class="text-secondary">Paid Tier</h6>
                                
                                <b-card-text>
                                    All of the features of Principal Task as well as the added 
                                    benefits of knowing that you are supporting both the growth
                                    of a small company and the improvement of Principal Task.  
                                </b-card-text>

                                
                            </b-card>

                            <b-collapse id="credit-info" :visible="localUserData.subscriptionTier == 'paid'">

                                <b-form-group
                                    id="signup-subscriptionLevel-group"
                                    label="Subscription Level"
                                    label-for="subscriptionLevel"
                                    description=""
                                    :state="localFormValidation.loadDefaults"
                                    valid-feedback="Looks good!"
                                    invalid-feedback="This information is required.">
                                        
                                    <b-form-select 
                                    id="subscriptionLevel"
                                    v-model.trim="localUserData.subscriptionLevel" 
                                    :state="localFormValidation.subscriptionLevel"
                                    :options="validSubscriptionLevels"
                                    value-field="item"
                                    text-field="name"/>

                                    <b-form-text>
                                        Your desired subscription level.  Subscriptions automatically renew. 
                                        <b-icon icon="question-circle" id="question-subscription"/>
                                    </b-form-text>

                                    <b-popover target="question-subscription" :triggers="['hover']" placement="top" variant="warning">
                                        <template v-slot:title>Subscriptions</template>
                                        <p>All subscriptions provide access to the same features.  Early Patrons will be given special privileges in the
                                        future.</p>
                                        <p>Subscriptions automatically renew.</p>
                                    </b-popover>

                                </b-form-group>

                                <b-form-group
                                    id="signup-loadDefaults-group"
                                    label="Payment Details"
                                    label-for="card-element"
                                    :state="localFormValidation.cardError">
                                        
                                    <!-- <div id="card-element" ref="card-element"></div> -->
                                    <StripeField
                                        ref="StripeField"
                                        @statusUpdate:StripeField="handleStripeFieldStatusUpdate"
                                        @newSubscription:StripeField="handleNewStripeSubscription"/>

                                    <b-form-text>
                                        Your payment card information (securely processed using <a href="https://www.stripe.com">Stripe</a>).
                                    </b-form-text>

                                    <b-form-invalid-feedback :state="localFormValidation.cardError" id="card-errors">
                                        {{localFormValidation.cardMessage}}
                                    </b-form-invalid-feedback>                            

                                </b-form-group>

                            </b-collapse>

                        </b-col>

                        </b-form-radio-group>

                    </b-form-row>

                    <b-form-row class="mt-2" style="text-align:right;">
                        <b-col>
                            <b-button variant="warning" @click="next('applicationOptions')" class="mr-2">
                                Previous
                            </b-button>
                            <b-button variant="success" @click="next('referral')">
                                Next
                            </b-button>
                        </b-col>
                    </b-form-row>

                </b-collapse>


                <b-form-row>
                    <b-col>
                        <p class="lead">
                            <b-link @click="collapse('referral')" style="text-decoration:none;">
                                <b-icon :icon="visibility.referralIcon"/>
                                <b-icon icon="exclamation-triangle-fill" variant="danger" v-if="typeof localFormValidation.referral != 'undefined' && localFormValidation.referral !== null && !localFormValidation.referral"/>
                                Referral
                            </b-link>
                        </p>
                    </b-col>
                </b-form-row>

                <b-collapse id="referral" :visible="visibility.referral">

                    <b-form-row>
                                
                        <b-col>
                                    
                        <b-form-group
                            id="signup-referredBy-group"
                            label="Referred By"
                            label-for="referredBy"
                            description="How you were referred to Principal Task."
                            :state="localFormValidation.referralSource"
                            valid-feedback="Looks good!"
                            invalid-feedback="This information is required."
                        >
                                
                            <b-form-select 
                            id="referredBy"
                            v-model.trim="localUserData.referralSource" 
                            :options="validReferralSources"
                            value-field="item"
                            text-field="name"
                            />

                        </b-form-group>

                        </b-col>

                        <b-col>
                                    
                        <b-form-group
                            id="signup-referralCode-group"
                            label="Referral Code"
                            label-for="referralCode"
                            description="Your referral code, if you have one."
                            :state="localFormValidation.referralCode" 
                            valid-feedback="Looks good!"
                            invalid-feedback="This information is required."
                        >
                                    
                            <b-form-input
                            id="referralCode"
                            v-model.trim="localUserData.referralCode" 
                            :state="localFormValidation.referralCode"
                            />

                        </b-form-group>

                        </b-col>

                    </b-form-row>

                    <b-form-row style="text-align:right;">
                        <b-col>
                            <b-button variant="warning" @click="next('subscription')" class="mr-2">
                                Previous
                            </b-button>
                            <b-button variant="success" @click="next('termsOfService')">
                                Next
                            </b-button>
                        </b-col>
                    </b-form-row>

                </b-collapse>

                <b-form-row>
                    <b-col>
                        <p class="lead">
                            <b-link @click="collapse('termsOfService')" style="text-decoration:none;">
                                <b-icon :icon="visibility.termsOfServiceIcon"/>
                                <b-icon icon="exclamation-triangle-fill" variant="danger" v-if="typeof localFormValidation.termsOfService != 'undefined' && localFormValidation.termsOfService !== null && !localFormValidation.termsOfService"/>
                                Terms of Service
                            </b-link>
                        </p>
                    </b-col>
                </b-form-row>

                <b-collapse id="termsOfService" :visible="visibility.termsOfService">
                
                    <b-form-row>
                                
                        <b-col>
                                    
                        <b-form-group
                            id="signup-privacypolicy-group"
                            label="Privacy Policy"
                            label-for="privacyPolicy"
                            :state="localFormValidation.privacyPolicy"
                            valid-feedback="Looks good!"
                            invalid-feedback="You must select Yes in order to continue."
                        >
                                
                            <b-form-select 
                            id="privacyPolicy"
                            v-model.trim="localUserData.privacyPolicy" 
                            :options="yesornoOnly"
                            value-field="item"
                            text-field="name"
                            />

                            <b-form-text>
                                Have you read and do you accept the 
                                <b-link to="privacy-policy" target="_blank">Privacy Policy</b-link>?
                            </b-form-text>

                        </b-form-group>

                        </b-col>

                        <b-col>
                                    
                        <b-form-group
                            id="signup-useragreement-group"
                            label="User Agreement"
                            label-for="userAgreement"
                            :state="localFormValidation.userAgreement" 
                            valid-feedback="Looks good!"
                            invalid-feedback="You must select Yes in order to continue."
                        >
                                    
                            <b-form-select 
                            id="userAgreement"
                            v-model.trim="localUserData.userAgreement" 
                            :options="yesornoOnly"
                            value-field="item"
                            text-field="name"
                            />

                            <b-form-text>
                                Have you read and do you accept the 
                                <b-link to="user-agreement" target="_blank">User Agreement</b-link>?
                            </b-form-text>

                        </b-form-group>

                        </b-col>

                    </b-form-row>
                </b-collapse>

                <b-form-row class="mb-2">
                    <b-col style="text-align:right;">
                    <b-button
                        ref="resetButton"
                        class="mr-2"
                        variant="warning"
                        type="reset"
                    >Cancel</b-button>
                    <b-button
                        ref="submitButton"
                        variant="success"
                        type="submit">Save</b-button>
                    </b-col>
                </b-form-row>
                    
            </b-form>
        </b-col>
    </b-row>

    </span>
  </span>
</template>

<script>

import countries from '../mixins/countries'
import genericOps from '../mixins/genericOps'
import Loading from '@/components/Loading.vue'
import LocalAuth0Service from '../services/LocalAuth0Service';
import Menu from '@/components/menus/Menu4.vue'
import momentTZ from 'moment-timezone'
import moment from 'moment'
import ProfileForm from '@/components/ProfileForm.vue'
import { RRule} from 'rrule'
import taskOps from '../mixins/taskOps'
import UserService from '../services/UserService';
import FolderService from '../services/FolderService'
import ContextService from '../services/ContextService'
import StripeField from '@/components/StripeField.vue'
import TaskService from '../services/TaskService'
import {v4 as UUIDService} from 'uuid';

export default {
    name: 'Signup',
    metaInfo() {
			return {
				title: 'Principal Task | Sign up',
				meta: [
					{
                        name: 'description',
                        content: 'Get started using Principal Task.'
                    }
				]
			}
		},
    components: {
      Loading,
      Menu,
      ProfileForm,
      StripeField,
	},
    mixins: [countries, genericOps, taskOps],
    data() {
        return {
            auth0User: {},
            loading: false,
            ptUserValidation: {
                applicationOptions: null,
                cardError: null,
                cardMessage: null,
                firstName: null,
                lastName: null,
                goesBy: null,
                country: null,
                personalData: null,
                timezone: null,
                referral: null,
                referralSource: null,
                referralCode: null,
                subscription: null,
                subscriptionLevel: null,
                termsOfService: null,
                loadDefaults: null,
            },
            testMessage: '',
            token: null,
            userData: {

            },
            validReferralSources: [
                {name: 'Business Card', item: 'business-card'},
                {name: 'Co-worker', item: 'coworker'},
                {name: 'Facebook', item: 'facebook'},
                {name: 'Family', item: 'family'},
                {name: 'Forum', item: 'forum'},
                {name: 'Friend', item: 'friend'},
                {name: 'Google or other Search Engine', item: 'search-engine'},
                {name: 'Instagram', item: 'instagram'},
                {name: 'LinkedIn', item: 'linkedin'},
                {name: 'Other', item: 'other'},
                {name: 'Social Media', item: 'social-media'},
                {name: 'Reddit', item: 'reddit'},
                {name: 'Slack', item: 'slack'},
                {name: 'Snapchat', item: 'snapchat'},
                {name: 'Twitter', item: 'twitter'},
            ],
            visibility: {
                applicationOptions: false,
                applicationOptionsIcon: 'chevron-compact-right',
                personalData: true,
                personalDataIcon: 'chevron-compact-down',
                referral: false,
                referralIcon: 'chevron-compact-right',
                subscription: false,
                subscriptionIcon: 'chevron-compact-right',
                termsOfService: false,
                termsOfServiceIcon: 'chevron-compact-right',
            }
            
        }
    },
    computed: {
        localUserData: {
            get: function() {
                
                return this.userData
            
            },
            set: function(newValue) {
            }
        },
        localFormValidation: {
            get: function() {
                return this.ptUserValidation
            },
            set: function(newValue) {
                //console.log('Setting localFormValidation to: ')
                //console.log(newValue)
                this.ptUserValidation = newValue
            }
        }
        
    },
    watch: {
        // call again the method if the route changes
        '$route': 'preparePage'
    },
    beforeRouteUpdate (to, from, next) {
      
        if(to.params.tier) {
            if(to.params.tier == 'free') {
                this.localUserData.subscriptionTier = 'free'
            } if(to.params.tier == 'paid') {
                this.localUserData.subscriptionTier = 'paid'
            }
        }
			

		next()
	},
    async created() {
        
        this.preparePage()

    },
    methods: {
        collapse(field) {

            //console.log('Updating field: ' + field)

            this.visibility[field] = !this.visibility[field]

            if(this.visibility[field]) {
                this.visibility[field + 'Icon'] = 'chevron-compact-down'
            } else {
                this.visibility[field + 'Icon'] = 'chevron-compact-right'
            }

        },
        async enrollmentComplete() {
            
            ////console.log('\n\nSignup.enrollmentComplete - Starting.\n\n')
            
            await this.$store.dispatch('loadUser').then((response) => {

                console.log('Success is ' + response)

            }).then(async () => {
                
                await this.$store.dispatch('loadContexts')
            
            }).then(async () => {

                await this.$store.dispatch('loadFolders')

            }).then(async () => {

                this.applyFilter(this.$store.getters.getUserPrefs.taskFilter)

                ////console.log('\n\nSignup.enrollmentComplete - Finished.\n\n')

                // Using payment details to determine if user is new and therefore
                // should be forwarded to the welcome page or if they're existing
                // and should be forwarded to the dashboard.
                if(typeof this.$store.getters.getPaymentDetails == 'undefined' || this.$store.getters.getPaymentDetails === null) {

                    this.$router.push({ name: 'dashboard' })

                } else {
                    this.$router.push({ name: 'welcome' })
                }

            }).catch((error) => {
                
                console.log('Error is: ' + error)

                this.$router.push({ name: 'error', params: {message: {title: 'Error gathering user data', body: error, variant: 'danger'}}})

            })
            
            
            

            
            
            

        },
        handleNewStripeSubscription(data) {

            this.localUserData.stripeCustomerId = data.customerId
            this.localUserData.stripeSubscriptionId = data.subscriptionId
            this.localUserData.stripeProductId = data.productId

            this.$store.commit('SET_PAYMENT_DETAILS', data.paymentDetails)

            this.createUser(this.localUserData)

        },
        handleStripeFieldStatusUpdate(data) {
            
            //console.log(data)

            this.$set(this.localFormValidation, 'cardError', data.cardError)
            this.$set(this.localFormValidation, 'cardMessage', data.cardMessage)

            if(data.showToast) {
                this.next('subscription')
                this.makeToast(true, 'Payment Issue', data.cardMessage, 'warning')
            }
            
            // this.localFormValidation.cardError = data.cardError
            // this.localFormValidation.cardMessage = data.cardMessage

            this.localFormValidation.subscription = data.cardError

            this.$refs.resetButton.disabled = false
            this.$refs.submitButton.disabled = false

        },
        next(field) {
            
            for(let key in this.visibility) {

                if(!key.includes('Icon')) {
                    this.visibility[key] = false
                    this.visibility[key + 'Icon'] = 'chevron-compact-right'
                }

            }
            
            
            this.collapse(field)
        },
        async onReset(evt){
            evt.preventDefault()

            //console.log('ProfileForm.onReset: Started.')

            this.$refs.resetButton.disabled = true
            this.$refs.submitButton.disabled = true

            let that = this

            await LocalAuth0Service.deleteUser(this.$auth.user.sub, this.$store.getters.getUserToken).then(function(response) {

                //console.log('LocalAuth0Service.deleteUser response: ')
                //console.log(response)

                try {

                    // Attempt to log the user out of Auth0.  They may already
                    // be logged out because their account has been deleted.
                    that.$auth.logout({
                        returnTo: window.location.origin
                    });

                } catch(e) {

                    // Assuming the exception is because the user was logged
                    // out due to their account being deleted.

                    //console.log('ProfileForm.onReset encountered an exception redirecting the user.')
                    //console.log(e)

                    that.$router.push({ name: 'home' }) 

                }
                

            }).catch((error) => {
                
                //////console.log('Error deleting user preferences: ' + error)
                this.makeToast(true, 'Delete User', 'Error deleting user from Auth0: ' + error, 'warning')

            })

        },
        onSubmit(evt) {
            
            // 20200409 -- ZWS -- Handles when a user submits the form.
            //
            // Validates the data and, if successful, emits the 
            // submitted:ProfileForm event.
            //
            // This disables the buttons.  The submitted.ProfileForm is
            // expected to enable them when appropriate.
            //
            // Emits: submitted:ProfileForm

            evt.preventDefault()
            
            this.$refs.resetButton.disabled = true
            this.$refs.submitButton.disabled = true

            //console.log('resetting form validation')
            this.localFormValidation = {}
            this.localFormValidation.valid = true

            if(typeof this.localUserData.firstName == 'undefined' || this.localUserData.firstName === null || this.localUserData.firstName.length < 1) {
                this.localFormValidation.valid = false  
                this.localFormValidation.firstName = false
                this.localFormValidation.personalData = false
            }

            if(typeof this.localUserData.lastName == 'undefined' || this.localUserData.lastName === null || this.localUserData.lastName.length < 1) {
                this.localFormValidation.valid = false  
                this.localFormValidation.lastName = false
                this.localFormValidation.personalData = false
            }

            if(typeof this.localUserData.loadDefaults == 'undefined' || this.localUserData.loadDefaults === null || this.localUserData.loadDefaults.length < 1) {
                this.localFormValidation.valid = false  
                this.localFormValidation.loadDefaults = false
                this.localFormValidation.personalData = false
            }

            if(typeof this.localUserData.subscriptionTier == 'undefined' || this.localUserData.subscriptionTier === null || this.localUserData.subscriptionTier.length < 1) {
                this.localFormValidation.valid = false  
                this.localFormValidation.subscriptionTier = false
                this.localFormValidation.subscription = false
            } else {

                if(this.localUserData.subscriptionTier != 'free') {

                    if(typeof this.localUserData.subscriptionLevel == 'undefined' || this.localUserData.subscriptionLevel === null || this.localUserData.subscriptionLevel.length < 1) {
                        this.localFormValidation.valid = false  
                        this.localFormValidation.subscriptionLevel = false
                        this.localFormValidation.subscription = false
                    }

                }

            }

            if(typeof this.localUserData.country == 'undefined' || this.localUserData.country === null || this.localUserData.country.length < 1) {
                this.localFormValidation.valid = false  
                this.localFormValidation.country = false
                this.localFormValidation.personalData = false
            
            }

            if(typeof this.localUserData.privacyPolicy == 'undefined' || this.localUserData.privacyPolicy === null || this.localUserData.privacyPolicy.length < 1) {
                this.localFormValidation.valid = false  
                this.localFormValidation.privacyPolicy = false
                this.localFormValidation.termsOfService = false
            }

            if(typeof this.localUserData.userAgreement == 'undefined' || this.localUserData.userAgreement === null || this.localUserData.userAgreement.length < 1) {
                this.localFormValidation.valid = false  
                this.localFormValidation.userAgreement = false
                this.localFormValidation.termsOfService = false
            }

            if(this.localFormValidation.valid) {

                ////console.log('\n\n\n\n\n\n\n\n ' + moment().format('MM/DD/YYYY HH:MI:SS'))
                
                if(this.localUserData.subscriptionTier != 'free') {

                    // this.createStripeCustomer(this.localUserData.firstName, this.localUserData.lastName, this.localUserData.email).then((result) => {
                    //     this.createStripePaymentMethod(this.stripeData.card, result.data.result.data.id, this.localUserData.subscriptionLevel)
                    // })

                    this.$refs.StripeField.createStripeCustomer(this.localUserData.firstName, this.localUserData.lastName, this.localUserData.email).then((result) => {
                        this.$refs.StripeField.createStripePaymentMethod(result.data.result.data.id, this.localUserData.subscriptionLevel)
                    })

                } else {

                    this.localUserData.subscriptionLevel = '2020-free'

                    this.createUser(this.localUserData)
                }
                
                
                
                
                
                
            } else {
                
                this.makeToast(true, 'Sign up Errors', 'Required information is missing.  Look for the exclamation icons.', 'warning')

                this.$refs.resetButton.disabled = false
                this.$refs.submitButton.disabled = false
            
            }

        },
        createUser(userData) {
            
            // Apply system defaults
            userData.signupDate = Number(momentTZ().format('x'))
            userData.version = '0.0.0'
            
            let that = this
            
            UserService.createUser(userData, this.token).then(async function(response) {
                
                //console.log('createUser returned: ' + JSON.stringify(response))

                let newUser = response.data.result.data

                // console.log('new user is: ' + JSON.stringify(newUser))

                // 20210103 -- ZWS -- Update Auth0 with user information.
                let appMetaData = that.$auth.user['https://www.principaltask.com/app_metadata'] || {}

                if((typeof appMetaData.pt_user_id == 'undefined' || appMetaData.pt_user_id === null) || appMetaData.pt_user_id != newUser._id) {

                    let updates = {
                        "app_metadata": {
                        "pt_user_id": newUser._id
                        }
                    }
            
                    // console.log('CUrrent token: ' + that.token);
                    
                    await LocalAuth0Service.updateUser(that.token, updates);

                    that.token = await that.$auth.getTokenSilently()

                    // console.log('Updated token: ' + that.token);

                    that.$store.dispatch('setUserToken', that.token)
                }

                await that.$store.dispatch('setUser', newUser)

                let prefsTemplate = {
                    defaultTaskOptions: {
                        priority: 'medium',
                        status: 'planning',
                        folder: 'Inbox',
                        context: null,
                        start: 1,
                        due: 1
                    },
                    taskFilter: {
                        completed: 'N',
                        context: null,
                        folder: null,
                        quickFilter: null,
                        location: 'Signup.vue'
                    },
                    taskSortOrder: {
                        first: 'title', 
                        second: 'start', 
                        third: 'due',
                        firstDirection: 1,
                        secondDirection: 1,
                        thirdDirection: 1
                    },
                }

                that.$store.dispatch('setUserPrefs', prefsTemplate)


                if(userData.loadDefaults == 'Y') {
                
                    let defaultFolders = [
                        {
                            name: 'Inbox',
                            group: 'Default',
                            private: 'Y',
                            active: 'Y',
                            customOrder: 0,
                            owner: newUser._id
                        },
                        {
                            name: 'Family',
                            group: 'Default',
                            private: 'Y',
                            active: 'Y',
                            customOrder: 5,
                            owner: newUser._id
                        },
                        {
                            name: 'Finances',
                            group: 'Default',
                            private: 'Y',
                            active: 'Y',
                            customOrder: 10,
                            owner: newUser._id
                        },
                        {
                            name: 'Personal',
                            group: 'Default',
                            private: 'Y',
                            active: 'Y',
                            customOrder: 15,
                            owner: newUser._id
                        },
                        {
                            name: 'Professional',
                            group: 'Default',
                            private: 'Y',
                            active: 'Y',
                            customOrder: 20,
                            owner: newUser._id
                        },                        
                    ]
                    
                    FolderService.addFolders(defaultFolders, that.token).then(await function(response) {
                        
                        //////console.log('FolderService.addFolders response: ' + JSON.stringify(response))
                        that.$store.dispatch('setFolders', response.data.result.data)

                    }).catch((error) => {
                        
                        //////console.log('Error creating folders: ' + error)
                        that.makeToast(true, 'Default Folders', 'Error creating default folders: ' + error, 'warning')

                    })

                    let defaultContexts = [
                        {
                            name: '@Home',
                            private: 'Y',
                            active: 'Y',
                            owner: newUser._id
                        },
                        {
                            name: '@School',
                            private: 'Y',
                            active: 'Y',
                            owner: newUser._id
                        },
                        {
                            name: '@Shopping',
                            private: 'Y',
                            active: 'Y',
                            owner: newUser._id
                        },
                        {
                            name: '@Work',
                            private: 'Y',
                            active: 'Y',
                            owner: newUser._id
                        },
                    ]

                    ContextService.addContexts(defaultContexts, that.token).then(await function(response) {
                    
                        ////console.log('ContextService.addContexts response: ' + JSON.stringify(response))
                        ////console.log('Contexts are: ' + JSON.stringify(response.data.response.data))
                        that.$store.dispatch('setContexts', response.data.response.data)
                    
                    }).catch((error) => {
                        
                        ////console.log('Error creating contexts: ' + error)
                        that.makeToast(true, 'Default Contexts', 'Error creating default contexts: ' + error, 'warning')
                    
                    })

                    let today = moment()

                    today.hour(0)
                    today.minute(0)
                    today.second(0)
                    today.millisecond(0)

                    let tomorrow = moment()
                    tomorrow.minute(0)
                    tomorrow.second(0)
                    tomorrow.millisecond(0)
                    tomorrow.add(1, 'days')
                    
                    let overmorrow = moment()
                    overmorrow.minute(0)
                    overmorrow.second(0)
                    overmorrow.millisecond(0)
                    overmorrow.add(2, 'days')
                    

                    //////console.log(today + ' -> ' + tomorrow + ' -> ' + overmorrow)

                    let todayMillis = today.format('x')
                    let tomorrowMillis = tomorrow.format('x')
                    let overmorrowMillis = overmorrow.format('x')

                    //////console.log(todayMillis + ' -> ' + tomorrowMillis + ' -> ' + overmorrowMillis)

                    let defaultTasks = [
                        {
                            title: '#1. Add every task I can think of to Principal Task',
                            start: Number(today.format('x')), 
                            due: Number(today.format('x')),
                            added: Number(today.format('x')), 
                            completed: 'N',
                            priority: 'top',
                            star: 'N',
                            status: 'next',
                            folder: 'Inbox',
                            notes: 'Gather all of the things I have to do.  Whether it\'s stored in my mind, in my email, on a sticky note, or wherever it may be.',
                            owner: newUser._id,
                            id:UUIDService()
                        },
                        {
                            title: '#2. Refine',
                            start: Number(tomorrow.format('x')), 
                            due: Number(tomorrow.format('x')),
                            added: Number(today.format('x')), 
                            completed: 'N',
                            priority: 'top',
                            star: 'N',
                            status: 'next',
                            folder: 'Inbox',
                            notes: 'Add detail to each task: update the notes with everything you know (or don\'t know) about it.',
                            owner: newUser._id,
                            id:UUIDService()
                        },
                        {
                            title: '#3. Organize',
                            start: Number(overmorrow.format('x')), 
                            due: Number(overmorrow.format('x')),
                            added: Number(today.format('x')), 
                            completed: 'N',
                            priority: 'top',
                            star: 'N',
                            status: 'next',
                            folder: 'Inbox',
                            notes: 'Review each task and put it in a folder, assign it a context, and set a time to start and complete it.',
                            owner: newUser._id,
                            id:UUIDService()
                        },
                        {
                            title: 'Process Inbox',
                            start: Number(overmorrow.format('x')), 
                            due: Number(overmorrow.format('x')),
                            added: Number(today.format('x')), 
                            completed: 'N',
                            repeat: {
                                freq: RRule.DAILY,
                                interval: 2
                            },
                            priority: 'top',
                            star: 'N',
                            status: 'next',
                            folder: 'Inbox',
                            notes: 'Review each task I\'ve collected and: \n* add detail: update the notes with everything I know (or don\'t know) about it\n* organize it: put it in a folder, assign it a context, and set a time to start and complete it.',
                            owner: newUser._id,
                            id:UUIDService()
                        },
                    ]

                    await TaskService.addTasks(defaultTasks, that.token).then(function(response) {
                    
                        //////console.log('TaskService.addTasks response: ' + JSON.stringify(response))
                        that.$store.dispatch('setTasks', response.data.response.data)
                    
                    }).catch((error) => {
                        
                        //////console.log('Error creating tasks: ' + error)
                        that.makeToast(true, 'Default Tasks', 'Error creating default tasks: ' + error, 'warning')
                    
                    })

                    that.enrollmentComplete()

                }


            }).catch(function(error) {

                ////console.log('SignUp.enrollmentComplete encountered an error when creating the user: ' + error)
                
                that.$refs.resetButton.disabled = false
                that.$refs.submitButton.disabled = false
                
                that.makeToast(true, 'Creating Account', 'Unable to create user: ' + error, 'danger')
                
                

            })

            // 20200409 -- ZWS -- TODO: Enable buttons on ProfileForm component
            // this.$refs.resetButton.disabled = false
            // this.$refs.submitButton.disabled = false

        },
        prepareForm() {
            
            //console.log('resetting form validation')
            this.localFormValidation = {}
            this.localFormValidation.valid = true

            this.localUserData.timezone = momentTZ.tz.guess(true)
            this.localUserData.loadDefaults = 'Y'
            
            let zoneNames = momentTZ.tz.names()

            this.validTimezones = zoneNames.map(x => {
                return {name: x, item: x}
            })
            
            try {
                this.$refs.resetButton.disabled = false
                this.$refs.submitButton.disabled = false
            } catch(e) {
                // Intentionally left blank.
            }

        },
        async preparePage() {
            
            this.loading = true

            this.token = await this.$auth.getTokenSilently()
            this.$store.dispatch('setUserToken', this.token)

            this.auth0User = await this.$auth.user
            let tempUser = await UserService.getUser(this.auth0User.email, this.token)

            // console.log(JSON.stringify(this.auth0User));

            /**************************************************** */

            
                
            if(typeof tempUser != 'undefined' && tempUser !== null) {
                
                this.testMessage = tempUser._id

                this.testMessage = 'Enrollment unnecessary.'

                this.$store.dispatch('setUser', tempUser)

                await this.enrollmentComplete()

            } else {
                
                console.log('Signup.vue - tempUser is undefined')

                this.userData = this.auth0User
                this.userData.firstName = this.auth0User.given_name;
                this.userData.lastName = this.auth0User.family_name;
                this.userData.goesBy = this.auth0User.given_name;
                this.prepareForm()

            }

            

            this.loading = false
        }
    }
}
</script>

<style scoped>

</style>